import apiClient from '@shared/lib/apiClient';
export async function startMfaEnrollment() {
    const { data } = await apiClient.post('/auth/mfa/enroll/start');
    return data;
}
/** Returns fresh tokens whose access JWT carries isMfaEnabled=true. */
export async function confirmMfaEnrollment(token) {
    const { data } = await apiClient.post('/auth/mfa/enroll/confirm', { token });
    return data;
}
export async function fetchPlatformOrganizations(params) {
    const { data } = await apiClient.get('/admin/platform/organizations', { params });
    return data;
}
export async function fetchPlatformOrgDetail(id) {
    const { data } = await apiClient.get(`/admin/platform/organizations/${id}`);
    return data;
}
export async function fetchPlatformOrgTransactions(id, params) {
    const { data } = await apiClient.get(`/admin/platform/organizations/${id}/transactions`, { params });
    return data;
}
export async function fetchPlatformOrgAccounts(id) {
    const { data } = await apiClient.get(`/admin/platform/organizations/${id}/accounts`);
    return data;
}
export async function fetchPlatformOrgCategories(id) {
    const { data } = await apiClient.get(`/admin/platform/organizations/${id}/categories`);
    return data;
}
export async function patchPlatformOrganization(id, body) {
    const { data } = await apiClient.patch(`/admin/platform/organizations/${id}`, body);
    return data;
}
export async function createPlatformOrganization(body) {
    const { data } = await apiClient.post('/admin/platform/organizations', body);
    return data;
}
export async function startPlatformImpersonation(organizationId) {
    const { data } = await apiClient.post('/admin/platform/impersonate', { organizationId });
    return data;
}
export async function addPlatformOrgMember(organizationId, body) {
    await apiClient.post(`/admin/platform/organizations/${organizationId}/members`, body);
}
export async function patchPlatformOrgMember(organizationId, userId, body) {
    await apiClient.patch(`/admin/platform/organizations/${organizationId}/members/${userId}`, body);
}
export async function removePlatformOrgMember(organizationId, userId) {
    await apiClient.delete(`/admin/platform/organizations/${organizationId}/members/${userId}`);
}
export async function fetchPlatformUsers(params) {
    // Super_admin-gated list (toPublic includes memberships). Consolidated onto /admin/platform/*;
    // the legacy /admin/users is deprecated (Sunset 2026-10-01).
    const { data } = await apiClient.get('/admin/platform/users', { params });
    return data;
}
export async function fetchPlatformUser(id) {
    const { data } = await apiClient.get(`/admin/platform/users/${id}`);
    return data;
}
export async function patchPlatformUser(id, body) {
    const { data } = await apiClient.patch(`/admin/platform/users/${id}`, body);
    return data;
}
export async function resetPlatformUserPassword(id, password) {
    await apiClient.post(`/admin/platform/users/${id}/reset-password`, { password });
}
export async function disablePlatformUserMfa(id) {
    await apiClient.post(`/admin/platform/users/${id}/mfa/disable`);
}
export async function fetchPlatformAudit(params) {
    const { data } = await apiClient.get('/admin/platform/audit', {
        params,
    });
    return data;
}
export async function exportPlatformAudit(params) {
    const format = params.format ?? 'csv';
    if (format === 'json') {
        const { data } = await apiClient.get('/admin/platform/audit/export', {
            params: { ...params, format: 'json' },
        });
        return data;
    }
    const { data } = await apiClient.get('/admin/platform/audit/export', {
        params: { ...params, format: 'csv' },
        responseType: 'blob',
    });
    return data;
}
/** Create a platform user. Super_admin-gated + ElevatedAccessGuard; audited via /admin/platform/*. */
export async function createPlatformUser(body) {
    const { data } = await apiClient.post('/admin/platform/users', body);
    return data;
}
export async function fetchRagDocuments(params) {
    const { data } = await apiClient.get('/admin/rag/documents', {
        params,
    });
    return data;
}
export async function fetchRagDocument(sourceKey) {
    const encoded = encodeURIComponent(sourceKey);
    const { data } = await apiClient.get(`/admin/rag/documents/${encoded}`);
    return data;
}
export async function upsertRagDocument(body) {
    const { data } = await apiClient.post('/admin/rag/documents', body);
    return data;
}
export async function deleteRagDocument(sourceKey) {
    const encoded = encodeURIComponent(sourceKey);
    const { data } = await apiClient.delete(`/admin/rag/documents/${encoded}`);
    return data;
}
export async function fetchAiSessions(params) {
    const { data } = await apiClient.get('/admin/ai/sessions', { params });
    return data;
}
export async function fetchAiTraces(params) {
    const { data } = await apiClient.get('/admin/ai/traces', { params });
    return data;
}
export async function fetchAiTraceDetail(id, obsLimit) {
    const { data } = await apiClient.get(`/admin/ai/traces/${id}`, {
        params: obsLimit ? { obsLimit } : undefined,
    });
    return data;
}
export async function fetchIntegrationsStatus() {
    const { data } = await apiClient.get('/admin/integrations/status');
    return data;
}
export async function fetchIntegrationsQueues() {
    const { data } = await apiClient.get('/admin/integrations/queues');
    return data;
}
export async function fetchNotionStatus() {
    const { data } = await apiClient.get('/admin/integrations/notion/status');
    return data;
}
export async function triggerNotionSync(entityType) {
    const { data } = await apiClient.post('/admin/integrations/notion/sync', { entityType });
    return data;
}
export async function fetchOtpWhatsAppStatus() {
    const { data } = await apiClient.get('/admin/integrations/evolution/otp');
    return data;
}
export async function createOtpWhatsAppInstance() {
    const { data } = await apiClient.post('/admin/integrations/evolution/otp/instance');
    return data;
}
/** Retorna o QR (Evolution): normalmente `{ base64, code, pairingCode, count }`. */
export async function connectOtpWhatsApp() {
    const { data } = await apiClient.post('/admin/integrations/evolution/otp/connect');
    return data;
}
export async function logoutOtpWhatsApp() {
    const { data } = await apiClient.post('/admin/integrations/evolution/otp/logout');
    return data;
}
export async function updateOtpWhatsAppSettings(patch) {
    const { data } = await apiClient.patch('/admin/integrations/evolution/otp', patch);
    return data;
}
